import React from 'react';

import LinkMore from '@app/components/LocalCommon/LinkMore/LinkMore';
import '@app/scss/components/mastheadBadge.scss';

interface MastheadBadgeProps {
	title: string;
	currentPage?: string;
	readMorePath: string;
	readMoreTitle?: string;
	imageSrc: string;
	imageAlt?: string;
}

const MastheadBadge: React.FC<MastheadBadgeProps> = (props) => (
	<div className="masthead masthead_badge">
		<div className="masthead-wrapper">
			<div className="masthead-wrapper-bottom" />
			<div className="masthead-body">
				<div className="masthead-body__left">
					{props.currentPage && <div className="masthead-body__top">{props.currentPage}</div>}
					<h1 className="masthead-body__title">{props.title}</h1>
					<LinkMore linkMoreCaption={props.readMoreTitle ?? 'Read more'} linkMoreLink={props.readMorePath} />
				</div>
				<img className="masthead-body__image" src={props.imageSrc} alt={props.imageAlt || ''} />
			</div>
		</div>
	</div>
);

export default MastheadBadge;
